import api from '@/ts/api';
import json from '@/ts/json';
import tools from '@/ts/tools';
import { WebsocketStore } from '@/ts/ws';
import { defineStore } from 'pinia';

export const Chats = defineStore('chats', {
  state: () => ({
        //
  }),

  getters: {
      // messages: (state) => (id) => state.list.filter(p => p.asset == id),
  },
  actions: {

    // get chat messages
    async get(id, limit, offset){
      let res = await api.send('admin/chats/get',{id: json.id(id), limit, offset})
      if (res.error) return []
      return res.resp || []
    },

    // get chat header (uid, title, image)
    async chat(id){
      let res = await api.send('admin/chats/chat',{id: json.id(id)})
      if (res.error) return {}
      return res.resp || {}
    },

    // get chat list
    async list(type, limit, offset){
      let res = await api.send('admin/chats/list',{type, limit, offset})
      if (res.error) return []
      return res.resp || []
    },


    subscribe(){
      // if (this.handler) return
      // const ws = WebsocketStore()
      // this.handler = this.add
      // let handle = this.handler
      // websocket.subscribe('admin/chats/subscribe', function(res){
      //   let message = res.resp
      //   if (!message) return
      //   handle(message)
      // })
    },

    // new messages and deletions of one chat; other packets also carry a chat field
    subscribeChat(chat, handler, onDelete){
      console.log('chats/subscribe', chat)
      const ws = WebsocketStore()
      return ws.handler((res) => {
        let message = res.resp
        if (!message || message.chat != chat) return
        if (res.name == 'chats/message') return handler(message)
        if (res.name == 'chats/message/delete' && typeof onDelete == 'function') onDelete(message.id)
      })
    },

    // delete any message (admin)
    async delete(id){
      if (!id) return {error: 'Message is not selected'}
      return await api.send('admin/chats/message/delete', {id: json.id(id)})
    },


     async send(chat, text, osfiles, reply, user){
      let filesList = Array.isArray(osfiles) ? osfiles : []
      let message = typeof text == 'string' ? text.trim() : text
      if (!chat) return {error: 'Chat is not selected'}
      if (!message && !filesList.length) return {error: 'Message is empty'}

      console.log("chat files", filesList)
      // upload files
      let files = await this.uploadingFiles(filesList)
      if (files && files.error) return files

      // try to send
      return await api.send('admin/chats/message', {chat: json.id(chat), text: message, reply: json.id(reply), files, user: json.id(user)})
    },

    async sendText(chat, text){
      if (!chat || !text) return
      return await api.send('admin/chats/message', {chat: json.id(chat), text})
    },

    // [1,2,3,4,5]
    read(messages){
      api.send('chats/read', {messages})
    },

    async uploadingFiles(files, asset) { //[]int
      if (!files || !files.length) return []
      let result = []
      for (let x = 0; x < files.length; x++) {
        const file = files[x];
         console.log("upload", file)
          let body = await tools.readFileAsBytes(file)
          if (!body) return {error: `Cannot read file: ${file.name || 'file'}`}
          let res = await api.upload.file(body, file.name, asset)
          if (res.error) {
            console.log("upload error", res.error)
            return res
          }
          result.push(res.resp.file.id)
          console.log("uploaded", res.resp.file)
      }

      console.log("uploaded files ids", result)

      return result
    },


  },
})


/*

type SupportChat struct {
    User    int    `json:"uid,omitempty"`
    Name    string `json:"name,omitempty"`
    Image   string `json:"image,omitempty"`
    Read    int64  `json:"read,omitempty"`
    Created int64  `json:"created,omitempty"`
    Message string `json:"message,omitempty"`
}

*/
